import { render, staticRenderFns } from "./bridge-details.vue?vue&type=template&id=04894040&scoped=true"
import script from "./bridge-details.vue?vue&type=script&lang=js"
export * from "./bridge-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04894040",
  null
  
)

export default component.exports